import './login.component.scss';

import type { FunctionComponent } from 'preact';
import { useEffect } from 'preact/hooks';
import { Provider } from 'react-redux';

import { LegacyAuthModalState, LoginType } from '../../../auth/models/auth.model';
import { authenticationFlowService } from '../../../auth/services/authentication-flow.service';
import { selectIsAuthenticated } from '../../../auth/store/auth.selectors';
import { checkAuthentication, initializeCustomer } from '../../../auth/store/auth.thunk';
import { store } from '../../../store';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';

export interface LoginProps {
  internalTitle: string;
  titleSize: string;
  description: string;
  buttonText: string;
  alignment: 'left' | 'center' | 'right';
  maxWidth: string;
  buttonFullWidth: string;
  // CSS Variables
  textColor: string;
  sectionBackgroundColor: string;
  buttonColor: string;
  buttonBorderColor: string;
  buttonTextColor: string;
  verticalPadding: string;
  horizontalPadding: string;
}

const LoginContent: FunctionComponent<LoginProps> = ({
  internalTitle,
  titleSize,
  description,
  buttonText,
  alignment,
  maxWidth,
  buttonFullWidth,
  textColor,
  sectionBackgroundColor,
  buttonColor,
  buttonBorderColor,
  buttonTextColor,
  verticalPadding,
  horizontalPadding,
}) => {
  const cssVars = {
    '--textColor': textColor,
    '--sectionBackgroundColor': sectionBackgroundColor,
    '--buttonColor': buttonColor,
    '--buttonBorderColor': buttonBorderColor,
    '--buttonTextColor': buttonTextColor,
    '--verticalPadding': verticalPadding,
    '--horizontalPadding': horizontalPadding,
  };

  const dispatch = useAppDispatch();
  const isAuthenticated = useAppSelector(selectIsAuthenticated);

  useEffect(() => {
    dispatch(checkAuthentication({ loginTypes: [LoginType.CUSTOMER] }));
    dispatch(initializeCustomer());
  }, [dispatch]);

  const openLoginModal = async () => {
    await authenticationFlowService.initiateAuthentication({ state: LegacyAuthModalState.LOGIN });
  };

  return (
    <>
      {!isAuthenticated && (
        <div class={`single-login-wrapper ${alignment}`} style={cssVars}>
          <div
            class={`single-login-container ${alignment} ${maxWidth === 'true' ? 'page-width' : ''}`}
          >
            <div class="single-login-header">
              {!!internalTitle && internalTitle !== '' && (
                <h2 class={`single-product-title ${titleSize}`}>
                  <span>{internalTitle}</span>
                </h2>
              )}

              {!!description && description !== '' && (
                <div class="description" dangerouslySetInnerHTML={{ __html: description }} />
              )}
            </div>

            <div class={`single-button-container ${alignment}`}>
              <button
                class={`btn button ${buttonFullWidth === 'true' ? 'full-width' : ''}`}
                onClick={openLoginModal}
              >
                {buttonText}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export const LoginComponent: FunctionComponent<LoginProps> = (props) => {
  return (
    <Provider store={store}>
      <LoginContent {...props} />
    </Provider>
  );
};
